import type {DocumentReference} from 'firebase/firestore'
import type {Course} from './Course'
import type {Organization} from './Organization'

export type GoSchoolUserRole = 'admin' | 'instructor' | 'student';

export interface GoSchoolUser {
  name: string
  email: string
  courses: DocumentReference<Course>[] | null;
  organization: DocumentReference<Organization>;
  organizations: {
    name: string,
    ref: DocumentReference<Organization>
  }[];
}

export function isGoSchoolUserRole(role: string): role is GoSchoolUserRole {
  return ['admin', 'instructor', 'student'].includes(role)
}

